export const getTimeMs = () => performance.now();

export const convertDaysToSeconds = (days: number) => days * 24 * 60 * 60;
